module.exports = __webpack_public_path__ + "static/media/dropdown-icon.2945e4c2.svg";